import { lazy, Suspense } from "react";
import { ThemeEffect } from "@/theme/theme";
import { UpdateBanner } from "@/app/UpdateBanner";
import { AuthGate } from "@/features/auth/AuthGate";
import { BootShell } from "@/ui/BootShell";

// The pages and their router are a second download (SignedInApp.tsx): the sign-in screen needs none of it.
let loading: ReturnType<typeof importApp> | null = null;
const importApp = () => import("@/app/SignedInApp");
/** Starts that download, once. */
export const loadSignedInApp = () => (loading ??= importApp());
const SignedInApp = lazy(loadSignedInApp);

export function App() {
  return (
    <>
      <ThemeEffect />
      <AuthGate warm={loadSignedInApp}>
        <Suspense fallback={<BootShell />}>
          <SignedInApp />
        </Suspense>
      </AuthGate>
      {import.meta.env.PROD && <UpdateBanner />}
    </>
  );
}
